import { render, staticRenderFns } from "./profile-orders.vue?vue&type=template&id=1f80778e&"
import script from "./profile-orders.vue?vue&type=script&lang=js&"
export * from "./profile-orders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports